import React from 'react';
import { motion } from 'framer-motion';
import { MarqueeRow } from './MarqueeRow';
import { keyFigures, referencesBottom, referencesTop } from '../../../data/references';
export function References() {
  const [primary, ...secondary] = keyFigures;
  return <section aria-labelledby="references-title" className="overflow-hidden bg-canvas pt-20 md:pt-28" data-id="element-208" data-mp="2aj8jxvix07np">
      <div className="shell grid gap-12 lg:grid-cols-12 lg:items-end" data-id="element-209" data-mp="2fdml6ek9d90a">
        <motion.h2 id="references-title" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[clamp(32px,4vw,56px)] font-medium leading-[1.02] tracking-[-0.035em] lg:col-span-6" data-id="element-210" data-mp="2kad191w2c4lp">
          Ils nous confient les décors qui partent en tournée.
        </motion.h2>

        <dl className="lg:col-span-6" data-id="element-211" data-mp="13vtim7zqtmjd">
          <div className="flex flex-row-reverse items-end justify-end gap-5" data-id="element-212" data-mp="13wv476edxrfc">
            <dt className="max-w-[12rem] pb-1 text-mute" data-id="element-213" data-mp="15sd8m7qzq7mw">{primary.label}</dt>
            <dd className="text-[clamp(72px,9vw,128px)] font-medium leading-[0.8] tracking-[-0.05em] text-ember" data-id="element-214" data-mp="110lghss6rtun">
              {primary.value}
            </dd>
          </div>
          <div className="mt-10 grid grid-cols-3 border-t border-line" data-id="element-215" data-mp="s05dekfcuoqb">
            {secondary.map(fig => <div key={fig.label} className="flex flex-col-reverse justify-end border-r border-line pr-4 pt-4 last:border-r-0 [&:not(:first-child)]:pl-4" data-id="element-216" data-mp="1oqxyjwh5b6yy">
                <dt className="mt-1 text-sm text-mute" data-id="element-217" data-mp="1fp84eivvptxh">{fig.label}</dt>
                <dd className="text-2xl font-medium tracking-[-0.03em] md:text-3xl" data-id="element-218" data-mp="1aqn64p06tkbo">{fig.value}</dd>
              </div>)}
          </div>
        </dl>
      </div>

      <div className="mt-16 border-y border-line md:mt-24" aria-label="Références" data-id="element-219" data-mp="4bvz03kh1397">
        <MarqueeRow items={referencesTop} data-id="element-220" data-mp="3vg42mum018ls" />
        <div className="border-t border-line" data-id="element-221" data-mp="sndsmov8u4e" />
        <MarqueeRow items={referencesBottom} reverse data-id="element-222" data-mp="tyj4qxym9xm" />
      </div>
    </section>;
}